/**
 * HowToUse
 */

import React from 'react';
import PropTypes from 'prop-types';
import TwoColumns from 'components/layout/TwoColumns/index.js';

function HowToUse(props) {
  const { children, className = 'my-5', locale } = props;
  return locale === 'nl' ? (
    <div className={className}>
      <h2 className="text-center mb-4">Hoe gebruik ik de koppelcode?</h2>

      <TwoColumns>
        <div>
          <h3>Ik heb al een account</h3>
          {children}
          <ul>
            <li>Zorg dat je ingelogd bent op Social Schools in de app of de webapp</li>
            <li>Klik dan op je naam in de bovenbalk</li>
            <li>
              {'Kies '}
              <span className="text-primary">&quot;koppelcode invoeren&quot;</span>
            </li>
          </ul>
        </div>
        <div>
          <h3>Ik heb nog geen account</h3>
          <p>Maak dan meteen je account aan:</p>
          <ul>
            <li>
              {'Ga naar '}
              <span className="text-primary">app.socialschools.eu</span>
            </li>
            <li>
              {'Klik op '}
              <span className="text-primary">&quot;Account maken&quot;.</span>
            </li>
            <li>Volg vervolgens de stappen.</li>
          </ul>
        </div>
      </TwoColumns>
    </div>
  ) : (
    <div className={className}>
      <h2 className="text-center fw-semibold">How to use this connection code?</h2>
      <TwoColumns>
        <div>
          <h3>If you already have an account</h3>
          {children}
          <ul>
            <li>Make sure you are logged in to the mobile or web app</li>
            <li>Click on your name in the top menu</li>
            <li>
              {'Select '}
              <span className="text-primary">&quot;Enter connection code&quot;</span>
            </li>
          </ul>
        </div>
        <div>
          <h3>If you don&apos;t have an account yet</h3>
          <p>Create a new account:</p>
          <ul>
            <li>
              {'Navigate to '}
              <span className="text-primary">https://app.socialschools.eu</span>
            </li>
            <li>
              {'Click '}
              <span className="text-primary">&quot;Create Account&quot;</span>
            </li>
            <li>Follow the instructions</li>
          </ul>
        </div>
      </TwoColumns>
    </div>
  );
}

HowToUse.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  locale: PropTypes.string,
};

export default HowToUse;
